var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgConfused = function SvgConfused(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9645_37842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37257 18.6274 0 12 0C5.37257 0 0 5.37257 0 12C0 18.6274 5.37257 24 12 24Z",
    fill: "#F7B239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.69519 18.3047C1.37845 13.9878 1.03829 7.2005 4.67446 2.49414C4.27167 2.80529 3.88411 3.14546 3.51465 3.51492C-1.17155 8.20112 -1.17155 15.799 3.51465 20.4852C8.20085 25.1713 15.7987 25.1714 20.4849 20.4852C20.8543 20.1157 21.1945 19.7281 21.5057 19.3253C16.7994 22.9616 10.012 22.6214 5.69519 18.3047Z",
    fill: "#E09B2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0163 16.5263H9.86471C9.619 16.5263 9.41992 16.3272 9.41992 16.0815C9.41992 15.8359 9.619 15.6367 9.86471 15.6367H14.0163C14.262 15.6367 14.4611 15.8358 14.4611 16.0815C14.4611 16.3272 14.2619 16.5263 14.0163 16.5263Z",
    fill: "#E09B2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6057 13.9766H6.27877C6.03306 13.9766 5.83398 14.1757 5.83398 14.4214C5.83398 14.667 6.03306 14.8661 6.27877 14.8661H17.6057C17.8514 14.8661 18.0505 14.667 18.0505 14.4214C18.0504 14.1757 17.8513 13.9766 17.6057 13.9766Z",
    fill: "#223137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33419 10.5821C8.33419 9.67475 7.59597 8.93652 6.68858 8.93652C5.78119 8.93652 5.04297 9.67475 5.04297 10.5821C5.04297 11.4895 5.78119 12.2277 6.68858 12.2277C7.59597 12.2277 8.33419 11.4895 8.33419 10.5821Z",
    fill: "#223137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3136 8.93652C16.4062 8.93652 15.668 9.67475 15.668 10.5821C15.668 11.4895 16.4062 12.2277 17.3136 12.2277C18.221 12.2277 18.9592 11.4895 18.9592 10.5821C18.9592 9.67475 18.221 8.93652 17.3136 8.93652Z",
    fill: "#223137"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9645_37842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConfused, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/confused.6f2f50cd.svg";
export { ForwardRef as ReactComponent };